(function () {
  const recentViewedProduct = document.querySelector(
    ".recently_viewed_proudct"
  );
  if (!recentViewedProduct) return;

  const recentViewedProductHandle =
    recentViewedProduct.dataset.productHandle || "";
  const storage = window.selinzaSafeStorage;
  const storageKey = "shopify-recent-view";
  const delimiter = ",";
  const gridSelector = "[grid-recentViewProduct]";

  document.addEventListener("DOMContentLoaded", function () {
    if (!recentViewedProductHandle) {
      console.error(
        "[Recently viewed] Missing `data-product-handle` attribute."
      );
      return;
    }

    updateRecentlyViewedProduct(recentViewedProductHandle);

    const recentGrid = document.querySelector(gridSelector);
    if (recentGrid) setupRecentGrid(recentGrid);
  });

  function setupRecentGrid(recentGrid) {
    const recentProducts = getRecentlyViewedProducts();
    if (recentProducts.length > 1) {
      recentViewedProduct.classList.remove("no-js-inline");
    }

    const requests = recentProducts
      .slice()
      .reverse()
      .filter((handle) => handle !== recentViewedProductHandle)
      .map((handle) => {
        const productTileTemplateUrl =
          "/products/" + encodeURIComponent(handle) + "?view=card";

        return fetch(productTileTemplateUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Recently viewed product request failed: ${response.status}`
              );
            }
            return response.text();
          })
          .catch((error) => {
            console.error("[Recently viewed]", error);
            return "";
          });
      });

    Promise.all(requests).then((responses) => {
      recentGrid.innerHTML = responses.filter(Boolean).join("");
    });
  }

  function getRecentlyViewedProducts() {
    const storedProducts = storage?.getItem(storageKey);
    if (!storedProducts) return [];

    return storedProducts
      .split(delimiter)
      .map((handle) => handle.trim())
      .filter(Boolean);
  }

  function setRecentlyViewedProducts(array) {
    const uniqueProducts = Array.from(new Set(array.filter(Boolean)));
    const storedProducts = uniqueProducts.join(delimiter);

    if (uniqueProducts.length) {
      storage?.setItem(storageKey, storedProducts);
    } else {
      storage?.removeItem(storageKey);
    }

    return uniqueProducts;
  }

  function updateRecentlyViewedProduct(handle) {
    const recentProducts = getRecentlyViewedProducts().filter(
      (storedHandle) => storedHandle !== handle
    );

    recentProducts.push(handle);
    return setRecentlyViewedProducts(recentProducts);
  }
})();
